<script setup>

import {ref, onMounted, onUpdated, computed} from 'vue';
const props = defineProps({
    message: String,
    show : {
        type : Boolean,
        default : false
    },
    type : {
        type : String,
        default : 'success'
    }
})
const emit = defineEmits(['update:show'])
const duration = 5; // thời gian chạy (giây)
const progressWidth = ref(100); // độ rộng ban đầu của đường kẻ là 100%

onMounted(() => {

});
onUpdated(() => {
    const interval = setInterval(() => {
        if (progressWidth.value > 0) {
            progressWidth.value -= 100 / (duration * 10); // giảm width mỗi 0.1 giây
        } else {
            emit('update:show',false)
            progressWidth.value = 100
            clearInterval(interval); // ngừng khi hết thời gian
        }
    }, 100); // mỗi 0.1 giây
})
const close = () => {
    emit('update:show',false)
}
const backgroundColor = computed(() => {
    switch (props.type) {
        case 'success':
            return '#23ac38';
        case 'warning':
            return 'rgb(251 146 60)';
        case 'danger':
            return 'rgb(248 113 113)';
        case 'info':
            return 'rgb(96 165 250)';
        default:
            return '#ccc'; // Màu mặc định nếu `type` không khớp
    }
});
</script>
<template>
    <Transition name="slide-fade">
        <div v-if="show" class="fixed w-96  top-5 right-0 z-50">
            <div class="">
                <div class="mx-2 ">
                    <div class="progress-bar-container">
                        <div
                            class="progress-bar"
                            :style="{ width: progressWidth + '%',
                                    backgroundColor: backgroundColor

                            }">
                        </div>
                    </div>
                    <div class="w-full flex items-center relative px-4 py-4  bg-white rounded-lg shadow-lg dark:bg-gray-800 dark:text-white">
                        <div v-if="type === 'success'" class="mr-1.5"><i class="far fa-check-circle text-green-400"></i></div>
                        <div v-if="type === 'warning'" class="mr-1.5"><i class="fas fa-exclamation-triangle text-orange-400"></i></div>
                        <div v-if="type === 'danger'" class="mr-1.5"><i class="fas fa-exclamation-circle text-red-400"></i></div>
                        <div v-if="type === 'info'" class="mr-1.5"><i class="fas fa-exclamation-circle text-blue-400"></i></div>
                        {{ message }}
                        <svg @click="close" class="cursor-pointer absolute top-5 right-4" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M12.667 3.33325L3.33365 12.6666M3.33365 3.33325L12.667 12.6666" stroke="#7A85A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>
<style scoped>
.progress-bar-container {
    width: 100%;
    height: 2px;
    background-color: #ddd; /* màu nền của container */
    border-radius: 100%;
    position: relative;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    position: absolute;
    left: 0; /* bắt đầu từ bên phải */
    transition: width 0.1s linear; /* tạo hiệu ứng mượt */
}
</style>
